import { CheckCircleIcon } from "staysure-component-library";

import { useCoverTypeContext } from "@/app/components/cover-type/provider/cover-type.provider";
import selectedColorBrand from "@/config/tailwind-colors/brand-colors";

function DetailSection() {
  const { magnoliaData } = useCoverTypeContext();

  const {
    detailTitleOne,
    detailDescriptionOne,
    detailTitleTwo,
    detailDescriptionTwo,
    detailTitleThree,
    detailDescriptionThree,
  } = magnoliaData.overlayArea[0];

  const detailItems = [
    {
      title: detailTitleOne,
      description: detailDescriptionOne,
    },
    {
      title: detailTitleTwo,
      description: detailDescriptionTwo,
    },
    {
      title: detailTitleThree,
      description: detailDescriptionThree,
    },
  ];

  return (
    <>
      {detailItems.map((item) => (
        <div
          key={`detail-${item.title}`}
          className="self-stretch justify-start items-start gap-spacing-xs inline-flex"
        >
          <div>
            <CheckCircleIcon
              fill={selectedColorBrand["icon-accent-2"]}
              stroke="#FFFFFF"
              data-testid="check-circle-icon"
            />
          </div>
          <div className="grow shrink basis-0 flex-col justify-center items-start gap-spacing-xxs inline-flex">
            <div className="text-confirmation-body text-2xs font-semibold sub-section-header-font leading-[24px]">
              {item.title}
            </div>
            <div className="self-stretch text-confirmation-body text-[14px] font-normal body-font leading-[21px]">
              {item.description}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default DetailSection;
